import { Page404, NoRouteMatched } from 'pages';
import { BlankLayout } from 'layouts';
import { makeRoute } from './helpers/makeRoute';
import {} from './middlewares';
import { locations } from './locations';

export default [
  makeRoute({
    path: locations.other.blankPage.pathname,
    component: Page404,
    layout: BlankLayout,
    middlewares: [],
  }),
  makeRoute({
    path: locations.other.noMatch.pathname,
    component: NoRouteMatched,
    middlewares: [],
  }),
];
